// Reusable scrollable panel for header + scroll + footer layouts
// Usage: <ScrollPanel header={<Header />} footer={<Footer />}>Content</ScrollPanel>
import React, { useEffect, useRef } from 'react';
import { OverlayScrollbars } from 'overlayscrollbars';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import colors from '../utils/theme/colors';

export default function ScrollPanel({ header, children, footer, style, scrollable = true }) {
  // attach custom scrollbars to this container so the bar never overlays content
  const scrollRef = useRef(null);

  useEffect(() => {
    if (!scrollable || !scrollRef.current) return undefined;
    const os = OverlayScrollbars(scrollRef.current, {
      scrollbars: { autoHide: 'leave' },
      overflow: { x: 'hidden', y: 'auto' },
    });
    return () => {
      if (os) os.destroy();
    };
  }, [scrollable]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        background: colors.background,
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {header && <div>{header}</div>}
      <div
        ref={scrollRef}
        style={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
          overflowY: scrollable ? 'auto' : 'hidden',
          overflowX: 'hidden',
          overscrollBehaviorX: 'none',
          boxSizing: 'border-box',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        {children}
      </div>
      {footer && <div>{footer}</div>}
    </div>
  );
}
